// Order status is derived from its fabrics (see backend/order_calc.py) —
// never set directly by a user.
export const ORDER_STATUS_META = {
  pending: { label: "Pendente", className: "border-border text-muted-foreground" },
  in_production: { label: "Em produção", className: "border-amber-500/50 text-amber-600 bg-amber-500/10" },
  done: { label: "Concluída", className: "border-emerald-500/50 text-emerald-600 bg-emerald-500/10" },
};

export const ORDER_STATUS_ORDER = ["pending", "in_production", "done"];

// Fabric (tecido/matriz) status: set automatically from cutting history, or
// manually overridden.
export const FABRIC_STATUS_META = {
  not_cut: { label: "Por cortar", className: "border-border text-muted-foreground" },
  cutting: { label: "Em corte", className: "border-amber-500/50 text-amber-600 bg-amber-500/10" },
  done: { label: "Cortado", className: "border-emerald-500/50 text-emerald-600 bg-emerald-500/10" },
};

export const FABRIC_STATUS_ORDER = ["not_cut", "cutting", "done"];

export const DEFECT_TYPES = ["Falha de tecido", "Mancha", "Corte errado", "Furo", "Outro"];
